import React from 'react'
import Link from 'next/link'
import { createPopper } from '@popperjs/core'

const IndexDropdown = ({ linkClasses }) => {
	// dropdown props
	const [dropdownPopoverShow, setDropdownPopoverShow] = React.useState(false)
	const btnDropdownRef = React.createRef()
	const popoverDropdownRef = React.createRef()
	const openDropdownPopover = () => {
		createPopper(btnDropdownRef.current, popoverDropdownRef.current, {
			placement: 'bottom-start',
		})
		setDropdownPopoverShow(true)
	}
	const closeDropdownPopover = () => {
		setDropdownPopoverShow(false)
	}
	return (
		<>
			<a
				className={
					linkClasses
						? linkClasses
						: 'hover:text-slate-500 text-slate-700 px-3 py-4 lg:py-2 flex items-center text-xs uppercase font-bold'
				}
				href='#pablo'
				ref={btnDropdownRef}
				onClick={(e) => {
					e.preventDefault()
					dropdownPopoverShow ? closeDropdownPopover() : openDropdownPopover()
				}}
			>
				Features
			</a>
			<div
				ref={popoverDropdownRef}
				className={
					(dropdownPopoverShow ? 'block ' : 'hidden ') +
					'bg-white text-base z-50 float-left py-2 list-none text-left rounded shadow-lg min-w-48'
				}
			>
				<span
					className={
						'text-sm pt-2 pb-0 px-4 font-bold block w-full whitespace-nowrap bg-transparent text-slate-400'
					}
				>
					Admin Layout
				</span>
				<Link legacyBehavior href='/admin/dashboard'>
					<a
						href='#pablo'
						className={
							'text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-slate-700'
						}
					>
						Dashboard
					</a>
				</Link>
				<Link legacyBehavior href='/admin/settings'>
					<a
						href='#pablo'
						className={
							'text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-slate-700'
						}
					>
						Settings
					</a>
				</Link>
				<Link legacyBehavior href='/admin/tables'>
					<a
						href='#pablo'
						className={
							'text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-slate-700'
						}
					>
						Tables
					</a>
				</Link>
				<Link legacyBehavior href='/admin/maps'>
					<a
						href='#pablo'
						className={
							'text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-slate-700'
						}
					>
						Maps
					</a>
				</Link>
				<div className='h-0 mx-4 my-2 border border-solid border-slate-100' />
				<span
					className={
						'text-sm pt-2 pb-0 px-4 font-bold block w-full whitespace-nowrap bg-transparent text-slate-400'
					}
				>
					Auth Layout
				</span>
				<Link legacyBehavior href='/auth/login'>
					<a
						href='#pablo'
						className={
							'text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-slate-700'
						}
					>
						Login
					</a>
				</Link>
				<Link legacyBehavior href='/auth/register'>
					<a
						href='#pablo'
						className={
							'text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-slate-700'
						}
					>
						Register
					</a>
				</Link>
				<div className='h-0 mx-4 my-2 border border-solid border-slate-100' />
				<span
					className={
						'text-sm pt-2 pb-0 px-4 font-bold block w-full whitespace-nowrap bg-transparent text-slate-400'
					}
				>
					No Layout
				</span>
				<Link legacyBehavior href='/landing'>
					<a
						href='#pablo'
						className={
							'text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-slate-700'
						}
					>
						Landing
					</a>
				</Link>
				<Link legacyBehavior href='/profile'>
					<a
						href='#pablo'
						className={
							'text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-slate-700'
						}
					>
						Profile
					</a>
				</Link>
			</div>
		</>
	)
}

export default IndexDropdown
